import React, { Component } from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import _ from 'lodash';

import NoData from '../../../components/NoData/NoData';

import { DatePicker } from '../../../components/Filter/components';
import DashboardInfo from '../../../components/DashboardInfo/DashboardInfo';
import { getSelectionValues } from '../../../util/filterUtils';

import CFDChart from '../components/CFD';
import CTSPChart from '../components/CTSP';
import CTBChart from '../components/CTB';
import CTHChart from '../components/CTH';
import CTAChart from '../components/CTA';
import TRCChart from '../components/TRC';

// Import Styles
import './../Overview.scss';

class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oct: 0,
      ct: 0,
      wip: 0,
      wipAvgAge: 0
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.ctsp != this.props.ctsp) {
      const eightyfifth = _.find(this.props.ctsp.percentiles, p => p.name == '85');
      if (eightyfifth) {
        this.setState({
          ct: eightyfifth.rawValue
        });
      }

      const overviewEightyFifth = _.find(this.props.ctsp.percentiles, p => p.name == '85');
      this.setState({
        oct: overviewEightyFifth ? overviewEightyFifth.rawValue : 0
      });
    }

    if (prevProps.cta != this.props.cta) {
      const wipAvgAge = _(this.props.cta.series)
        .flatMap('data')
        .meanBy('cycleTimeInMinutes');

      this.setState({
        wipAvgAge
      });
    }

    if (prevProps.cfd != this.props.cfd) {
      let wip = 0;
      _(this.props.cfd)
        .filter(l => {
          return (
            this.props.dashboard.todo.indexOf(l.listId) === -1 && this.props.dashboard.done.indexOf(l.listId) === -1
          );
        })
        .forEach(l => {
          let last = _.last(l.data);
          wip += last.daily;
        });

      this.setState({
        wip
      });
    }
  }

  renderSystemMetrics() {
    let stats = _.first(this.props.cfdStats);

    let systemAvgArrivalRate = stats ? stats.avgArrivalRate : 0.0;
    let systemAvgThroughput = stats ? stats.avgThroughput : 0.0;
    let systemAvgDailyWIP = stats ? stats.avgDailyWIP : 0;
    let systemAvgCycleTime = moment
      .duration(stats ? stats.avgCycleTime : 0, 'days')
      .format(this.props.timePrecision, { trim: 'mid both' });

    return (
      <div className='info-box-content'>
        <div className='info-box-item'>
          <h4>{systemAvgArrivalRate.toFixed(2)}</h4>
          <p>Arrival Rate items/day</p>
        </div>
        <div className='info-box-item'>
          <h4>{systemAvgThroughput.toFixed(2)}</h4>
          <p>Throughput items/day</p>
        </div>
        <div className='info-box-item'>
          <h4>{systemAvgDailyWIP.toFixed(2)}</h4>
          <p>Daily WIP items</p>
        </div>
        <div className='info-box-item'>
          <h4>{systemAvgCycleTime}</h4>
          <p>Cycle Time</p>
        </div>
      </div>
    );
  }

  render() {
    const { queueLists, allQueueLists } = this.props;
    const showFlowEfficiency = getSelectionValues(queueLists, allQueueLists).length < allQueueLists.length;

    return (
      <div className='content-wrap overview'>
        <div className='overview-header'>
          <div className='title-info'>
            <p>Overview</p>
            <DashboardInfo dashboard={this.props.dashboard} />
          </div>
          
          <div className='overview-header-right-elements'>
            <DatePicker />
          </div>
        </div>
        
        <div className="row-cell-list">
          <div className={`cell cell-sm-height ${showFlowEfficiency && 'cell-25'}`}>
            <div className='cell-header'><h4>Cycle Time</h4></div>
            <div className="cell-content cell-justify-center">
              <div className='info-box-item'>
                <h4>{moment.duration(this.state.oct, 'minutes').format(this.props.timePrecision, {trim: 'mid both'})} or less</h4>
                <p>were needed to complete</p>
              </div>
              <div className='info-box-item'>
                <h4>85%</h4>
                <p>work items</p>
              </div>
            </div>
          </div>
             
          <div className={`cell cell-sm-height ${showFlowEfficiency && 'cell-25'}`}>
            <div className='cell-header'><h4>WIP</h4></div>
            <div className='cell-content cell-justify-center'>
              <div className='info-box-item'>
                <h4>
                  {this.state.wip} work item{this.state.wip != 1 ? 's' : ''}
                </h4>
                <p>{this.state.wip != 1 ? 'are' : 'is'} currently in progress</p>
              </div>
              <div className='info-box-item'>
                <h4>
                  {moment
                    .duration(this.state.wipAvgAge, 'minutes')
                    .format(this.props.timePrecision, { trim: 'mid both' })}
                </h4>
                <p>WIP average age</p>
              </div>
            </div>
          </div>

          {showFlowEfficiency && (
            <div className='cell cell-sm-height cell-25'>
              <div className='cell-header'><h4>Flow Efficiency</h4></div>
              <div className='cell-content cell-justify-center '>
                <div className='info-box-item'>
                  <h4>{this.props.avgFe.avgFe || '0.00'}%</h4>
                  <p>Average Flow Efficiency</p>
                </div>
              </div>
            </div>
          )}

          <div className={`cell cell-sm-height ${showFlowEfficiency && 'cell-25'}`}>
            <div className='cell-header'><h4>Average Process Metrics</h4></div>
            <div className='cell-content cell-justify-center'>
              {this.renderSystemMetrics()}
            </div>
          </div>
              
          <div className='cell'>
            <div className='cell-header'><h4>Cumulative Flow Diagram</h4></div>
            {this.props.cfd.length > 0 &&
              <div className='cell-content'>
                <CFDChart id="Overview_CFD" className="chart" data={this.props.cfd} />
              </div>
            }
            
            <NoData
              className="cell-content overview_CFD"
              show={!this.props.cfd.length}
              loading={this.props.cfdLoading}
            />
          </div>

          <div className='cell'>
            <div className='cell-header'><h4>Cycle Time Scatterplot</h4></div>
            {(this.props.ctsp.series && this.props.ctsp.series.length > 0) &&
              <div className='cell-content'>
                <CTSPChart id="Overview_CTSP" className="chart" data={this.props.ctsp} />
              </div>
            }
            
            <NoData
              className="cell-content overview_CTSP"
              show={this.props.ctsp.series && !this.props.ctsp.series.length}
              loading={this.props.ctspLoading}
            />
          </div>

          <div className='cell'>
            <div className='cell-header'><h4>Cycle Time Breakdown Chart</h4></div>
            {(this.props.ctb.breakdown && this.props.ctb.breakdown.length > 0) &&
              <div className='cell-content'>
                <CTBChart id="Overview_CTB" className="chart" data={this.props.ctb.breakdown} />
              </div>
            }

            <NoData
              className="cell-content overview_CTB"
              show={this.props.ctb.breakdown && !this.props.ctb.breakdown.length}
              loading={this.props.ctbLoading}
            />
          </div>

          <div className='cell'>
            <div className='cell-header'><h4>Cycle Time Histogram</h4></div>
            {(this.props.cth.series && this.props.cth.series.length > 0) &&
              <div className='cell-content'>
                <CTHChart id="Overview_CTH" className="chart" data={this.props.cth} />
              </div>
            }

            <NoData
              className="cell-content overview_CTH"
              show={this.props.cth.series && !this.props.cth.series.length}
              loading={this.props.cthLoading}
            />
          </div>

          <div className='cell'>
            <div className='cell-header'><h4>Aging Chart</h4></div>
            {(this.props.cta.series && this.props.cta.series.length > 0) &&
              <div className='cell-content'>
                <CTAChart id="Overview_CTA" className="chart" data={this.props.cta} />
              </div>
            }

            <NoData
              className="cell-content overview_CTA"
              show={this.props.cta.series && !this.props.cta.series.length}
              loading={this.props.ctaLoading}
            />
          </div>

          <div className='cell'>
            <div className='cell-header'><h4>Throughput Run Chart</h4></div>
            {this.props.trc.length &&
              <div className='cell-content'>
                <TRCChart id="Overview_TRC" className="chart" data={this.props.trc} />
              </div>
            }

            <NoData 
              className="cell-content overview_TRC"
              show={!this.props.trc.length} 
              loading={this.props.trcLoading} 
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    enabledColors: state.filters.enabledColors,
    timePrecision: state.filters.timePrecision,
    queueLists: state.filters.overview.selectedQueueLists,
    allQueueLists: state.filters.allQueueLists,
    hash: state.filters.overview.hash,

    overviewLoading: state.app.overviewLoading,
    dataIsLoading: state.app.isLoading,
    dataHash: state.app.dataHash,

    dashboard: state.dashboards.selected,

    cfd: state.overview.cfd,
    cfdLoading: state.overview.cfdLoading,
    cfdStats: state.overview.cfdStats,
    ctsp: state.overview.ctsp,
    ctspLoading: state.overview.ctspLoading,
    ctb: state.overview.ctb,
    ctbLoading: state.overview.ctbLoading,
    cth: state.overview.cth,
    cthLoading: state.overview.cthLoading,
    cta: state.overview.cta,
    ctaLoading: state.overview.ctaLoading,
    trc: state.overview.trc,
    trcLoading: state.overview.trcLoading,
    avgFe: state.overview.avgFe
  };
};

export default connect(mapStateToProps)(Overview);
